'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject;
var InputGroup$1 = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  margin: 8px 0;\n"])));

var InputGroup = React__default['default'].forwardRef(function InputGroup(_ref, forwardedRef) {
  var children = _ref.children,
      props = defaultTheme._objectWithoutProperties(_ref, ["children"]);

  return React__default['default'].createElement(InputGroup$1, defaultTheme._extends({
    ref: forwardedRef
  }, props), children);
});
InputGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  children: defaultTheme.PropTypes.node
} : {};
InputGroup.defaultProps = {};

exports.InputGroup = InputGroup;
